module.exports = __webpack_public_path__ + "img/article6.3c74c1ac.jpg";